import { Engine } from 'engine/Engine';
import { Entity } from 'engine/Entity';
import { ColliderFacet, ColliderType } from 'engine/facets/ColliderFacet';
import { Facet } from 'engine/facets/Facet';
import { SpriteGroupFacet } from 'engine/facets/SpriteGroupFacet';
import { StaticSpriteFacet } from 'engine/facets/StaticSpriteFacet';
import { V2 } from 'engine/lib/V2';
import { create } from 'engine/lib/create';
import { Activatable } from 'game/behaviors/Activatable';
import { FILTER_OUTLINE_ID } from 'game/defs/FilterOutline';
import { inGameUIClasses } from 'game/styles/inGameUI';
import { createElement } from 'react';
import { ScannerBehavior } from './LabWallDoorEntity';
import { ScannerScanError, ScannerScanLine, ScannerSprite } from './LabWallSprite';

const offset: V2 = [-15, -170];

interface ScannerProps {
  door: Entity,
}

interface ScanProps extends ScannerProps {
  scanLine: StaticSpriteFacet,
  scanError: StaticSpriteFacet,
}

class ScanBehavior extends Facet<ScanProps> {
  update(delta: number, engine: Engine) {
    const scanner = this.props.door.getFacet(ScannerBehavior);
    if (!scanner) return;
    if (engine.input.keyDown.KeyF && this.entity.getFacet(Activatable)?.active) {
      scanner.scan(engine);
    }
    if (!scanner.scanStart) {
      this.props.scanLine.props.opacity = 0;
      this.props.scanError.props.opacity = 0;
      return;
    }
    const deltaScan = engine.time.now - scanner.scanStart;
    const progress = deltaScan / (scanner.scanDuration - 450);
    this.props.scanLine.props.opacity = progress >= 1 ? 0 : 1;
    this.props.scanLine.props.offset![1] = -170 + progress * 56;
    this.props.scanError.props.opacity = (deltaScan >= 1000) ? 1 : 0;
  }
}

export class ScannerEntity extends Entity<ScannerProps> {
  createFacets(props: ScannerProps) {
    const sprite = create(SpriteGroupFacet, {
      children: [create(StaticSpriteFacet, { frame: ScannerSprite, offset })],
    });
    const scanLine = create(StaticSpriteFacet, { frame: ScannerScanLine, offset: [...offset], opacity: 0 });
    const scanError = create(StaticSpriteFacet, { frame: ScannerScanError, offset });
    let text: StaticSpriteFacet | null = null;
    return [
      sprite,
      scanLine,
      scanError,
      create(ScanBehavior, { door: props.door, scanLine, scanError }),
      create(ColliderFacet, { type: ColliderType.Box, size: [30, 60], offset: [-15, 0], trigger: true }),
      create(Activatable, {
        activate: (active, engine) => {
          sprite.props.filter = active ? `url(#${FILTER_OUTLINE_ID})` : undefined;

          if (active) {
            text = create(StaticSpriteFacet, {
              frame: createElement('text', {
                className: inGameUIClasses.activatedText,
                y: -210,
              }, '[f] Scan'),
            });
            this.addFacet(text, engine);
          } else if (text) {
            this.removeFacet(text);
          }
        },
      }),
    ];
  }
}
